import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PledgeLimitState {
  pledgeLimitData: any | null;
}

const initialState: PledgeLimitState = {
  pledgeLimitData: null,
};

export const pledgeLimitSlice = createSlice({
  name: "pledgeLimit",
  initialState,
  reducers: {
    setPledgeLimitData: (state, action: PayloadAction<any>) => {
      state.pledgeLimitData = action.payload;
    },
    clearPledgeLimitData: (state) => {
      state.pledgeLimitData = null;
    },
    updatePledgeLimitData: (state, action: PayloadAction<Partial<any>>) => {
      if (state.pledgeLimitData) {
        state.pledgeLimitData = {
          ...state.pledgeLimitData,
          ...action.payload,
        };
      }
    },
  },
});

export const { setPledgeLimitData, clearPledgeLimitData, updatePledgeLimitData } = pledgeLimitSlice.actions;

export default pledgeLimitSlice.reducer;